export const routes = [
  {
    path: "/sala-principal/:id/sala-5w2h",
    component: () => import(/* webpackChunkName: "ur" */ "./components/List"),
    name: "sala.indicadores.municipio.sala-5w2h",
    meta: {
      requiresAuth: true,
    },
  },
];
